import developer from "../Assets/Images/Services/development.webp";
import designer from "../Assets/Images/Services/design.webp";
import marketer from "../Assets/Images/Services/digital.webp";
import uiux from "../Assets/Images/Services/uiux.webp";
import app from "../Assets/Images/Services/app.webp";
import seo from "../Assets/Images/Services/seo.webp";
import marketing from "../Assets/Images/Services/digitalMarketing.webp";
import WebDevelopment from "../Assets/Images/Services/webDevelopment.webp";
import contentWrite from "../Assets/Images/Services/contentWrite.webp";
import icon1 from "../Assets/Images/Services/Icon.webp";
import icon2 from "../Assets/Images/Services/Icon.webp";
import icon3 from "../Assets/Images/Services/Icon (1).webp";
import icon4 from "../Assets/Images/Services/Icon (3).webp";

import web from "../Assets/Images/Services/web (1).webp";
import design from "../Assets/Images/Services/app (1).webp";
import apps from "../Assets/Images/Services/design (2).webp";
import digital from "../Assets/Images/Services/digital (1).webp";

export const mainServices = [
  {
    title: "Web Development",
    slug: "web-development",
    image: web,
    shortDescription:
      "IT Ghar specializes in Website Design and Development Services.",

    _id: 1,
    icon: icon1,
    banner: developer,
    description: {
      content1:
        "IT Ghar has extensive experience in developing high-performance",
      items: [
        "Website Design: They offer custom website design services to create visually appealing and user-friendly websites that reflect the brand identity of their clients.",
        "Front-end Development: They specialize in front-end technologies such as HTML, CSS, and JavaScript to create interactive and responsive websites that provide a seamless user experience.",
        "Back-end Development: They develop scalable and secure back-end systems using technologies like PHP, Ruby on Rails, and Node.js to power the websites and web applications.",
        "Content Management Systems (CMS): They provide CMS integration services to help clients manage and update their website content easily.",
        "E-commerce Solutions: They offer e-commerce development services to help businesses sell products and services online.",
        "Search Engine Optimization (SEO): They provide SEO services to help clients improve their website's search engine ranking and visibility.",
        "Website Hosting and Maintenance: They offer reliable and secure website hosting services and provide ongoing website maintenance and support to keep their clients' websites up-to-date and functioning smoothly.",
      ],
      content2:
        "Overall, IT Ghar Company's web development services are aimed at helping businesses establish a strong online presence and achieve their goals.",
    },
  },
  {
    title: "App Development",
    slug: "app-development",
    shortDescription:
      "IT Ghar has extensive experience in developing high-performance.",
    description: {
      content1:
        "IT Ghar Company provides comprehensive app development services for businesses and organizations. Their services include:",
      items: [
        "Mobile App Development: They offer custom mobile app development services for iOS and Android platforms to help businesses reach their target audience through smartphones and tablets.",
        "Cross-platform Development: They develop cross-platform apps that work seamlessly across multiple operating systems and devices.",
        "Native App Development: They specialize in developing high-performance and user-friendly native apps that take full advantage of the capabilities of the underlying device.",
        "App Design: They offer custom app design services to create visually appealing and intuitive app interfaces that provide a seamless user experience.",
        "App Maintenance and Support: They provide ongoing app maintenance and support services to ensure their clients' apps are up-to-date, secure, and functioning smoothly.",
        "Integration with Back-end Systems: They provide services to integrate apps with back-end systems, such as databases, APIs, and cloud services, to provide a seamless user experience.",
      ],
      content2:
        "IT Ghar Company's app development services are aimed at helping businesses reach their target audience through mobile devices, increase their brand awareness, and achieve their goals. They use the latest technologies and methodologies to develop high-quality and reliable apps that meet the needs of their clients.",
    },
    _id: 2,
    icon: icon2,
    banner: app,
    image: apps,
  },
  {
    title: "Graphic Design",
    slug: "graphic-design",
    shortDescription:
      "The IT Ghar overcomes product Graphic Design challenges every day. ",
    description: {
      content1:
        "IT Ghar Company offers comprehensive graphic design services to businesses and organizations. Their services include:",
      items: [
        "Logo Design: They provide custom logo design services to help businesses establish a unique and recognizable brand identity.",
        "Brand Identity Design: They offer brand identity design services to create a consistent and cohesive visual representation of a brand across multiple platforms and mediums.",
        "Print Design: They specialize in creating high-quality print materials such as business cards, brochures, flyers, and posters to promote businesses and their products and services.",
        "Digital Design: They provide digital design services for websites, social media platforms, email campaigns, and other online mediums to create engaging and visually appealing content.",
        "Packaging Design: They offer packaging design services to create attractive and functional packaging that appeals to consumers and effectively showcases the product.",
        "Illustration: They provide custom illustration services to create unique and engaging illustrations for various mediums and platforms.",
      ],
      content2:
        "IT Ghar Company's graphic design services are aimed at helping businesses create a strong visual identity, communicate their message effectively, and achieve their marketing goals. They use a combination of creativity, technical expertise, and industry experience to deliver high-quality and impactful graphic design solutions.",
    },
    _id: 3,
    icon: icon3,
    banner: designer,
    image: design,
  },
  {
    title: "Digital  Marketing",
    slug: "digital-marketing",
    shortDescription:
      "IT Ghars is a Power Innovation Digital Marketing Company.",
    description: {
      content1:
        "IT Ghar Company provides comprehensive digital marketing services to businesses and organizations. Their services include:",
      items: [
        "Search Engine Optimization (SEO): They offer SEO services to help clients improve their website's visibility and ranking on search engines like Google and Bing.",
        "Pay-Per-Click (PPC) Advertising: They provide PPC advertising services to help businesses reach their target audience through platforms like Google Ads and Facebook Ads.",
        "Social Media Marketing: They specialize in creating and executing social media marketing campaigns to help businesses reach and engage with their target audience through platforms like Facebook, Twitter, and Instagram.",
        "Email Marketing: They provide email marketing services to help businesses reach and engage with their target audience through personalized and targeted email campaigns.",
        "Content Marketing: They offer content marketing services to help businesses create and distribute high-quality and engaging content to attract and retain their target audience.",
        "Video Marketing: They provide video marketing services to help businesses reach their target audience through engaging and impactful video content on platforms like YouTube and Vimeo.",
      ],
      content2:
        "IT Ghar Company's digital marketing services are aimed at helping businesses reach their target audience, increase their brand awareness, and achieve their marketing goals. They use data-driven strategies and the latest technologies to deliver effective and results-oriented digital marketing solutions.",
    },
    _id: 4,
    icon: icon4,
    banner: marketer,
    image: digital,
  },
  {
    title: "Search Engine Optimization ",
    slug: "search-engine-optimization",
    shortDescription:
      " Search engine optimization for online stores is known as eCommerce SEO",

    description: {
      content1:
        "IT Ghar Company provides comprehensive search engine optimization (SEO) services to businesses and organizations. Their services include:",
      items: [
        "Keyword Research: They conduct in-depth keyword research to identify the keywords and phrases that are relevant to the client's business and target audience.",
        "On-page Optimization: They optimize the client's website's content, structure, and meta-data to ensure that it is search engine friendly and optimized for the target keywords.",
        "Off-page Optimization: They implement off-page optimization techniques such as link building and social media marketing to improve the client's website's visibility and authority in the eyes of search engines.",
        "Local SEO: They provide local SEO services to help businesses rank higher in search engine results for local searches and reach their target audience in a specific geographical location.",
        "Technical SEO: They provide technical SEO services to help clients optimize their website's technical aspects, such as site speed, mobile responsiveness, and security, to ensure that it is optimized for search engines.",
        "Reporting and Analysis: They provide regular reporting and analysis to help clients understand the performance of their website in search engines and track the progress of their SEO efforts.",
      ],
      content2:
        "IT Ghar Company's SEO services are aimed at helping businesses improve their website's visibility and ranking in search engines, reach their target audience, and achieve their marketing goals. They use data-driven strategies and the latest best practices to deliver effective and results-oriented SEO solutions.",
    },
    _id: 5,
    icon: "fa-solid fa-magnifying-glass-chart",
    banner: seo,
  },
  {
    title: "UI UX Design",
    slug: "ui-ux-design",
    shortDescription:
      " The IT Ghar overcomes product design challenges every day. ",
    description: {
      content1:
        "IT Ghar Company offers comprehensive UI/UX design services to businesses and organizations. Their services include:",
      items: [
        "User Research: They conduct user research to understand the needs, goals, and behaviors of the target audience and to inform the design process.",
        "Wireframing and Prototyping: They create wireframes and prototypes to visualize the overall structure and functionality of the product and to test and validate design decisions.",
        "Interaction Design: They design the interactions and animations that bring the product to life and create a seamless and engaging user experience.",
        "Visual Design: They create visually appealing and cohesive design systems that align with the brand's style and aesthetic.",
        "Usability Testing: They conduct usability testing to validate the design decisions and to identify any usability issues that need to be addressed.",
        "Design Systems and Guidelines: They develop design systems and guidelines to ensure consistency and efficiency in the design process and to facilitate the handoff to development.",
      ],
      content2:
        "IT Ghar Company's UI/UX design services are aimed at helping businesses create intuitive and engaging user experiences that meet the needs and goals of the target audience. They use a user-centered approach and the latest design thinking methodologies to deliver high-quality and effective UI/UX design solutions.",
    },
    _id: 6,
    icon: "far fa-edit",
    banner: uiux,
  },
];

export const subServices = [
  {
    title: "Social Media Marketing",
    type: "Digital Marketing",
    slug: "social-media-marketing",
    shortDescription:
      "IT Ghar specializes in Website Design and Development Services.",
    description: {
      content1:
        "IT Ghar Company provides comprehensive digital marketing services to businesses and organizations. Their services include:",
      items: [
        "Search Engine Optimization (SEO): They offer SEO services to help clients improve their website's visibility and ranking on search engines like Google and Bing.",
        "Pay-Per-Click (PPC) Advertising: They provide PPC advertising services to help businesses reach their target audience through platforms like Google Ads and Facebook Ads.",
        "Social Media Marketing: They specialize in creating and executing social media marketing campaigns to help businesses reach and engage with their target audience through platforms like Facebook, Twitter, and Instagram.",
        "Email Marketing: They provide email marketing services to help businesses reach and engage with their target audience through personalized and targeted email campaigns.",
        "Content Marketing: They offer content marketing services to help businesses create and distribute high-quality and engaging content to attract and retain their target audience.",
        "Video Marketing: They provide video marketing services to help businesses reach their target audience through engaging and impactful video content on platforms like YouTube and Vimeo.",
      ],
      content2:
        "IT Ghar Company's digital marketing services are aimed at helping businesses reach their target audience, increase their brand awareness, and achieve their marketing goals. They use data-driven strategies and the latest technologies to deliver effective and results-oriented digital marketing solutions.",
    },
    _id: 101,
    icon: "fa-solid fa-layer-group",
    banner: marketing,
  },
  {
    title: " Social Media Advertising",
    slug: "social-media-advertising",
    type: "Digital Marketing",
    shortDescription:
      "IT Ghar has extensive experience in developing high-performance.",
    description: {
      content1:
        "IT Ghar Company provides comprehensive digital marketing services to businesses and organizations. Their services include:",
      items: [
        "Search Engine Optimization (SEO): They offer SEO services to help clients improve their website's visibility and ranking on search engines like Google and Bing.",
        "Pay-Per-Click (PPC) Advertising: They provide PPC advertising services to help businesses reach their target audience through platforms like Google Ads and Facebook Ads.",
        "Social Media Marketing: They specialize in creating and executing social media marketing campaigns to help businesses reach and engage with their target audience through platforms like Facebook, Twitter, and Instagram.",
        "Email Marketing: They provide email marketing services to help businesses reach and engage with their target audience through personalized and targeted email campaigns.",
        "Content Marketing: They offer content marketing services to help businesses create and distribute high-quality and engaging content to attract and retain their target audience.",
        "Video Marketing: They provide video marketing services to help businesses reach their target audience through engaging and impactful video content on platforms like YouTube and Vimeo.",
      ],
      content2:
        "IT Ghar Company's digital marketing services are aimed at helping businesses reach their target audience, increase their brand awareness, and achieve their marketing goals. They use data-driven strategies and the latest technologies to deliver effective and results-oriented digital marketing solutions.",
    },
    _id: 102,
    icon: "fa-brands fa-app-store-ios",
    banner: marketing,
  },
  {
    title: "Search Engine Optimization",
    slug: "search-engine-optimization",
    type: "Digital Marketing",
    shortDescription:
      "IT Ghar specializes in Website Design and Development Services. ",

    description: {
      content1:
        "IT Ghar Company provides comprehensive search engine optimization (SEO) services to businesses and organizations. Their services include:",
      items: [
        "Keyword Research: They conduct in-depth keyword research to identify the keywords and phrases that are relevant to the client's business and target audience.",
        "On-page Optimization: They optimize the client's website's content, structure, and meta-data to ensure that it is search engine friendly and optimized for the target keywords.",
        "Off-page Optimization: They implement off-page optimization techniques such as link building and social media marketing to improve the client's website's visibility and authority in the eyes of search engines.",
        "Local SEO: They provide local SEO services to help businesses rank higher in search engine results for local searches and reach their target audience in a specific geographical location.",
        "Technical SEO: They provide technical SEO services to help clients optimize their website's technical aspects, such as site speed, mobile responsiveness, and security, to ensure that it is optimized for search engines.",
        "Reporting and Analysis: They provide regular reporting and analysis to help clients understand the performance of their website in search engines and track the progress of their SEO efforts.",
      ],
      content2:
        "IT Ghar Company's SEO services are aimed at helping businesses improve their website's visibility and ranking in search engines, reach their target audience, and achieve their marketing goals. They use data-driven strategies and the latest best practices to deliver effective and results-oriented SEO solutions.",
    },
    _id: 103,
    icon: "fa-solid fa-compass-drafting",
    banner: marketing,
  },
  {
    title: "Marketing Strategy",
    slug: "marketing-strategy",
    type: "Digital Marketing",
    shortDescription:
      "IT Ghars is a Power Innovation Digital Marketing Company.",
    description: {
      content1:
        "IT Ghar Company provides comprehensive digital marketing services to businesses and organizations. Their services include:",
      items: [
        "Search Engine Optimization (SEO): They offer SEO services to help clients improve their website's visibility and ranking on search engines like Google and Bing.",
        "Pay-Per-Click (PPC) Advertising: They provide PPC advertising services to help businesses reach their target audience through platforms like Google Ads and Facebook Ads.",
        "Social Media Marketing: They specialize in creating and executing social media marketing campaigns to help businesses reach and engage with their target audience through platforms like Facebook, Twitter, and Instagram.",
        "Email Marketing: They provide email marketing services to help businesses reach and engage with their target audience through personalized and targeted email campaigns.",
        "Content Marketing: They offer content marketing services to help businesses create and distribute high-quality and engaging content to attract and retain their target audience.",
        "Video Marketing: They provide video marketing services to help businesses reach their target audience through engaging and impactful video content on platforms like YouTube and Vimeo.",
      ],
      content2:
        "IT Ghar Company's digital marketing services are aimed at helping businesses reach their target audience, increase their brand awareness, and achieve their marketing goals. They use data-driven strategies and the latest technologies to deliver effective and results-oriented digital marketing solutions.",
    },
    _id: 104,
    icon: "fa-solid fa-chart-simple",
    banner: marketing,
  },
  {
    title: " Marketing Advice",
    type: "Digital Marketing",
    slug: "marketing-advice",
    shortDescription:
      " Search engine optimization for online stores is known as eCommerce SEO",
    description: {
      content1:
        "IT Ghar Company provides comprehensive digital marketing services to businesses and organizations. Their services include:",
      items: [
        "Search Engine Optimization (SEO): They offer SEO services to help clients improve their website's visibility and ranking on search engines like Google and Bing.",
        "Pay-Per-Click (PPC) Advertising: They provide PPC advertising services to help businesses reach their target audience through platforms like Google Ads and Facebook Ads.",
        "Social Media Marketing: They specialize in creating and executing social media marketing campaigns to help businesses reach and engage with their target audience through platforms like Facebook, Twitter, and Instagram.",
        "Email Marketing: They provide email marketing services to help businesses reach and engage with their target audience through personalized and targeted email campaigns.",
        "Content Marketing: They offer content marketing services to help businesses create and distribute high-quality and engaging content to attract and retain their target audience.",
        "Video Marketing: They provide video marketing services to help businesses reach their target audience through engaging and impactful video content on platforms like YouTube and Vimeo.",
      ],
      content2:
        "IT Ghar Company's digital marketing services are aimed at helping businesses reach their target audience, increase their brand awareness, and achieve their marketing goals. They use data-driven strategies and the latest technologies to deliver effective and results-oriented digital marketing solutions.",
    },
    _id: 105,
    icon: "fa-solid fa-magnifying-glass-chart",
    banner: marketing,
  },
  {
    title: "Logo Design",
    slug: "logo-design",
    type: "Graphics & Design",
    shortDescription:
      " Search engine optimization for online stores is known as eCommerce SEO",
    description: {
      content1:
        "IT Ghar Company offers comprehensive graphic design services to businesses and organizations. Their services include:",
      items: [
        "Logo Design: They provide custom logo design services to help businesses establish a unique and recognizable brand identity.",
        "Brand Identity Design: They offer brand identity design services to create a consistent and cohesive visual representation of a brand across multiple platforms and mediums.",
        "Print Design: They specialize in creating high-quality print materials such as business cards, brochures, flyers, and posters to promote businesses and their products and services.",
        "Digital Design: They provide digital design services for websites, social media platforms, email campaigns, and other online mediums to create engaging and visually appealing content.",
        "Packaging Design: They offer packaging design services to create attractive and functional packaging that appeals to consumers and effectively showcases the product.",
        "Illustration: They provide custom illustration services to create unique and engaging illustrations for various mediums and platforms.",
      ],
      content2:
        "IT Ghar Company's graphic design services are aimed at helping businesses create a strong visual identity, communicate their message effectively, and achieve their marketing goals. They use a combination of creativity, technical expertise, and industry experience to deliver high-quality and impactful graphic design solutions.",
    },
    _id: 106,
    icon: "far fa-edit",
    banner: designer,
  },
  {
    title: " Brand Style Guides",
    slug: "brand-style-guides",
    type: "Graphics & Design",
    shortDescription:
      " Search engine optimization for online stores is known as eCommerce SEO",
    description: {
      content1:
        "IT Ghar Company offers comprehensive graphic design services to businesses and organizations. Their services include:",
      items: [
        "Logo Design: They provide custom logo design services to help businesses establish a unique and recognizable brand identity.",
        "Brand Identity Design: They offer brand identity design services to create a consistent and cohesive visual representation of a brand across multiple platforms and mediums.",
        "Print Design: They specialize in creating high-quality print materials such as business cards, brochures, flyers, and posters to promote businesses and their products and services.",
        "Digital Design: They provide digital design services for websites, social media platforms, email campaigns, and other online mediums to create engaging and visually appealing content.",
        "Packaging Design: They offer packaging design services to create attractive and functional packaging that appeals to consumers and effectively showcases the product.",
        "Illustration: They provide custom illustration services to create unique and engaging illustrations for various mediums and platforms.",
      ],
      content2:
        "IT Ghar Company's graphic design services are aimed at helping businesses create a strong visual identity, communicate their message effectively, and achieve their marketing goals. They use a combination of creativity, technical expertise, and industry experience to deliver high-quality and impactful graphic design solutions.",
    },
    _id: 107,
    icon: "far fa-edit",
    banner: designer,
  },
  {
    title: " Fashion Design",
    slug: "fashion-design",
    type: "Graphics & Design",
    shortDescription:
      " Search engine optimization for online stores is known as eCommerce SEO",
    description: {
      content1:
        "IT Ghar Company offers comprehensive graphic design services to businesses and organizations. Their services include:",
      items: [
        "Logo Design: They provide custom logo design services to help businesses establish a unique and recognizable brand identity.",
        "Brand Identity Design: They offer brand identity design services to create a consistent and cohesive visual representation of a brand across multiple platforms and mediums.",
        "Print Design: They specialize in creating high-quality print materials such as business cards, brochures, flyers, and posters to promote businesses and their products and services.",
        "Digital Design: They provide digital design services for websites, social media platforms, email campaigns, and other online mediums to create engaging and visually appealing content.",
        "Packaging Design: They offer packaging design services to create attractive and functional packaging that appeals to consumers and effectively showcases the product.",
        "Illustration: They provide custom illustration services to create unique and engaging illustrations for various mediums and platforms.",
      ],
      content2:
        "IT Ghar Company's graphic design services are aimed at helping businesses create a strong visual identity, communicate their message effectively, and achieve their marketing goals. They use a combination of creativity, technical expertise, and industry experience to deliver high-quality and impactful graphic design solutions.",
    },
    _id: 108,
    icon: "far fa-edit",
    banner: designer,
  },
  {
    title: "Social Media Design",
    slug: "social-media-design",
    type: "Graphics & Design",
    shortDescription:
      " Search engine optimization for online stores is known as eCommerce SEO",
    description: {
      content1:
        "IT Ghar Company offers comprehensive graphic design services to businesses and organizations. Their services include:",
      items: [
        "Logo Design: They provide custom logo design services to help businesses establish a unique and recognizable brand identity.",
        "Brand Identity Design: They offer brand identity design services to create a consistent and cohesive visual representation of a brand across multiple platforms and mediums.",
        "Print Design: They specialize in creating high-quality print materials such as business cards, brochures, flyers, and posters to promote businesses and their products and services.",
        "Digital Design: They provide digital design services for websites, social media platforms, email campaigns, and other online mediums to create engaging and visually appealing content.",
        "Packaging Design: They offer packaging design services to create attractive and functional packaging that appeals to consumers and effectively showcases the product.",
        "Illustration: They provide custom illustration services to create unique and engaging illustrations for various mediums and platforms.",
      ],
      content2:
        "IT Ghar Company's graphic design services are aimed at helping businesses create a strong visual identity, communicate their message effectively, and achieve their marketing goals. They use a combination of creativity, technical expertise, and industry experience to deliver high-quality and impactful graphic design solutions.",
    },
    _id: 109,
    icon: "far fa-edit",
    banner: designer,
  },
  {
    title: "UX Design",
    slug: "ux-design",
    type: "Graphics & Design",
    shortDescription:
      " Search engine optimization for online stores is known as eCommerce SEO",
    description: {
      content1:
        "IT Ghar Company offers comprehensive graphic design services to businesses and organizations. Their services include:",
      items: [
        "Logo Design: They provide custom logo design services to help businesses establish a unique and recognizable brand identity.",
        "Brand Identity Design: They offer brand identity design services to create a consistent and cohesive visual representation of a brand across multiple platforms and mediums.",
        "Print Design: They specialize in creating high-quality print materials such as business cards, brochures, flyers, and posters to promote businesses and their products and services.",
        "Digital Design: They provide digital design services for websites, social media platforms, email campaigns, and other online mediums to create engaging and visually appealing content.",
        "Packaging Design: They offer packaging design services to create attractive and functional packaging that appeals to consumers and effectively showcases the product.",
        "Illustration: They provide custom illustration services to create unique and engaging illustrations for various mediums and platforms.",
      ],
      content2:
        "IT Ghar Company's graphic design services are aimed at helping businesses create a strong visual identity, communicate their message effectively, and achieve their marketing goals. They use a combination of creativity, technical expertise, and industry experience to deliver high-quality and impactful graphic design solutions.",
    },
    _id: 110,
    icon: "far fa-edit",
    banner: designer,
  },
  {
    title: "Website Development",
    slug: "website-development",
    type: "Programming & Tech",
    shortDescription:
      " Search engine optimization for online stores is known as eCommerce SEO",
    description: {
      content1:
        "IT Ghar Company offers comprehensive web development services to businesses and organizations. Their services include:",
      items: [
        "Website Design: They offer custom website design services to create visually appealing and user-friendly websites that reflect the brand identity of their clients.",
        "Front-end Development: They specialize in front-end technologies such as HTML, CSS, and JavaScript to create interactive and responsive websites that provide a seamless user experience.",
        "Back-end Development: They develop scalable and secure back-end systems using technologies like PHP, Ruby on Rails, and Node.js to power the websites and web applications.",
        "Content Management Systems (CMS): They provide CMS integration services to help clients manage and update their website content easily.",
        "E-commerce Solutions: They offer e-commerce development services to help businesses sell products and services online.",
        "Search Engine Optimization (SEO): They provide SEO services to help clients improve their website's search engine ranking and visibility.",
        "Website Hosting and Maintenance: They offer reliable and secure website hosting services and provide ongoing website maintenance and support to keep their clients' websites up-to-date and functioning smoothly.",
      ],
      content2:
        "Overall, IT Ghar Company's web development services are aimed at helping businesses establish a strong online presence and achieve their goals.",
    },
    _id: 111,
    icon: "far fa-edit",
    banner: WebDevelopment,
  },
  {
    title: "Mobile Apps",
    slug: "mobile-apps",
    type: "Programming & Tech",
    shortDescription:
      " Search engine optimization for online stores is known as eCommerce SEO",
    description: {
      content1:
        "IT Ghar Company provides comprehensive app development services for businesses and organizations. Their services include:",
      items: [
        "Mobile App Development: They offer custom mobile app development services for iOS and Android platforms to help businesses reach their target audience through smartphones and tablets.",
        "Cross-platform Development: They develop cross-platform apps that work seamlessly across multiple operating systems and devices.",
        "Native App Development: They specialize in developing high-performance and user-friendly native apps that take full advantage of the capabilities of the underlying device.",
        "App Design: They offer custom app design services to create visually appealing and intuitive app interfaces that provide a seamless user experience.",
        "App Maintenance and Support: They provide ongoing app maintenance and support services to ensure their clients' apps are up-to-date, secure, and functioning smoothly.",
        "Integration with Back-end Systems: They provide services to integrate apps with back-end systems, such as databases, APIs, and cloud services, to provide a seamless user experience.",
      ],
      content2:
        "IT Ghar Company's app development services are aimed at helping businesses reach their target audience through mobile devices, increase their brand awareness, and achieve their goals. They use the latest technologies and methodologies to develop high-quality and reliable apps that meet the needs of their clients.",
    },
    _id: 112,
    icon: "far fa-edit",
    banner: WebDevelopment,
  },
  {
    title: "Business Websites",
    slug: "business-websites",
    type: "Programming & Tech",
    shortDescription:
      " Search engine optimization for online stores is known as eCommerce SEO",
    description: {
      content1:
        "IT Ghar Company offers comprehensive web development services to businesses and organizations. Their services include:",
      items: [
        "Website Design: They offer custom website design services to create visually appealing and user-friendly websites that reflect the brand identity of their clients.",
        "Front-end Development: They specialize in front-end technologies such as HTML, CSS, and JavaScript to create interactive and responsive websites that provide a seamless user experience.",
        "Back-end Development: They develop scalable and secure back-end systems using technologies like PHP, Ruby on Rails, and Node.js to power the websites and web applications.",
        "Content Management Systems (CMS): They provide CMS integration services to help clients manage and update their website content easily.",
        "E-commerce Solutions: They offer e-commerce development services to help businesses sell products and services online.",
        "Search Engine Optimization (SEO): They provide SEO services to help clients improve their website's search engine ranking and visibility.",
        "Website Hosting and Maintenance: They offer reliable and secure website hosting services and provide ongoing website maintenance and support to keep their clients' websites up-to-date and functioning smoothly.",
      ],
      content2:
        "Overall, IT Ghar Company's web development services are aimed at helping businesses establish a strong online presence and achieve their goals.",
    },
    _id: 113,
    icon: "far fa-edit",
    banner: WebDevelopment,
  },
  {
    title: "E-Commerce Development",
    slug: "e-Commerce-development",
    type: "Programming & Tech",
    shortDescription:
      " Search engine optimization for online stores is known as eCommerce SEO",
    description: {
      content1:
        "IT Ghar Company offers comprehensive web development services to businesses and organizations. Their services include:",
      items: [
        "Website Design: They offer custom website design services to create visually appealing and user-friendly websites that reflect the brand identity of their clients.",
        "Front-end Development: They specialize in front-end technologies such as HTML, CSS, and JavaScript to create interactive and responsive websites that provide a seamless user experience.",
        "Back-end Development: They develop scalable and secure back-end systems using technologies like PHP, Ruby on Rails, and Node.js to power the websites and web applications.",
        "Content Management Systems (CMS): They provide CMS integration services to help clients manage and update their website content easily.",
        "E-commerce Solutions: They offer e-commerce development services to help businesses sell products and services online.",
        "Search Engine Optimization (SEO): They provide SEO services to help clients improve their website's search engine ranking and visibility.",
        "Website Hosting and Maintenance: They offer reliable and secure website hosting services and provide ongoing website maintenance and support to keep their clients' websites up-to-date and functioning smoothly.",
      ],
      content2:
        "Overall, IT Ghar Company's web development services are aimed at helping businesses establish a strong online presence and achieve their goals.",
    },
    _id: 114,
    icon: "far fa-edit",
    banner: WebDevelopment,
  },
  {
    title: "Landing Pages",
    slug: "landing-pages",
    type: "Programming & Tech",
    shortDescription:
      " Search engine optimization for online stores is known as eCommerce SEO",
    description: {
      content1:
        "IT Ghar Company offers comprehensive web development services to businesses and organizations. Their services include:",
      items: [
        "Website Design: They offer custom website design services to create visually appealing and user-friendly websites that reflect the brand identity of their clients.",
        "Front-end Development: They specialize in front-end technologies such as HTML, CSS, and JavaScript to create interactive and responsive websites that provide a seamless user experience.",
        "Back-end Development: They develop scalable and secure back-end systems using technologies like PHP, Ruby on Rails, and Node.js to power the websites and web applications.",
        "Content Management Systems (CMS): They provide CMS integration services to help clients manage and update their website content easily.",
        "E-commerce Solutions: They offer e-commerce development services to help businesses sell products and services online.",
        "Search Engine Optimization (SEO): They provide SEO services to help clients improve their website's search engine ranking and visibility.",
        "Website Hosting and Maintenance: They offer reliable and secure website hosting services and provide ongoing website maintenance and support to keep their clients' websites up-to-date and functioning smoothly.",
      ],
      content2:
        "Overall, IT Ghar Company's web development services are aimed at helping businesses establish a strong online presence and achieve their goals.",
    },
    _id: 115,
    icon: "far fa-edit",
    banner: WebDevelopment,
  },
  {
    title: "Articles & Blog Posts",
    slug: "articles-&-blog-posts",
    type: "Writing & Translation",
    shortDescription:
      " Search engine optimization for online stores is known as eCommerce SEO",
    description: {
      content1:
        "IT Ghar Company provides comprehensive writing and translation services to businesses and organizations. Their services include:",
      items: [
        "Content Writing: They provide professional writing services to help businesses create high-quality and engaging content for websites, blogs, social media, email campaigns, and other marketing materials.",
        "Technical Writing: They specialize in creating clear and concise technical documentation for software, hardware, and other technical products.",
        "Translation: They offer translation services to help businesses communicate effectively with their target audience in multiple languages. Their translation services cover a wide range of industries, including technology, finance, healthcare, and more.",
        "Localization: They provide localization services to help businesses adapt their content, products, and services to meet the cultural and linguistic needs of specific geographical locations.",
        "Copywriting: They provide copywriting services to help businesses create compelling and persuasive copy for advertising, marketing, and sales materials.",
      ],
      content2:
        "IT Ghar Company's writing and translation services are aimed at helping businesses communicate effectively and reach their target audience in multiple languages. They use a professional and quality-oriented approach and the latest technologies to deliver accurate and effective writing and translation solutions.",
    },
    _id: 116,

    icon: "far fa-edit",
    banner: contentWrite,
  },
  {
    title: " Book & eBook Writing",
    slug: "book-&-eBook-writing",
    type: " Writing & Translation",
    shortDescription:
      " Search engine optimization for online stores is known as eCommerce SEO",

    description: {
      content1:
        "IT Ghar Company provides comprehensive writing and translation services to businesses and organizations. Their services include:",
      items: [
        "Content Writing: They provide professional writing services to help businesses create high-quality and engaging content for websites, blogs, social media, email campaigns, and other marketing materials.",
        "Technical Writing: They specialize in creating clear and concise technical documentation for software, hardware, and other technical products.",
        "Translation: They offer translation services to help businesses communicate effectively with their target audience in multiple languages. Their translation services cover a wide range of industries, including technology, finance, healthcare, and more.",
        "Localization: They provide localization services to help businesses adapt their content, products, and services to meet the cultural and linguistic needs of specific geographical locations.",
        "Copywriting: They provide copywriting services to help businesses create compelling and persuasive copy for advertising, marketing, and sales materials.",
      ],
      content2:
        "IT Ghar Company's writing and translation services are aimed at helping businesses communicate effectively and reach their target audience in multiple languages. They use a professional and quality-oriented approach and the latest technologies to deliver accurate and effective writing and translation solutions.",
    },
    _id: 117,
    icon: "far fa-edit",
    banner: contentWrite,
  },
  {
    title: "Cover Letters",
    slug: "cover-letters",
    type: "Writing & Translation",
    shortDescription:
      " Search engine optimization for online stores is known as eCommerce SEO",
    description: {
      content1:
        "IT Ghar Company provides comprehensive writing and translation services to businesses and organizations. Their services include:",
      items: [
        "Content Writing: They provide professional writing services to help businesses create high-quality and engaging content for websites, blogs, social media, email campaigns, and other marketing materials.",
        "Technical Writing: They specialize in creating clear and concise technical documentation for software, hardware, and other technical products.",
        "Translation: They offer translation services to help businesses communicate effectively with their target audience in multiple languages. Their translation services cover a wide range of industries, including technology, finance, healthcare, and more.",
        "Localization: They provide localization services to help businesses adapt their content, products, and services to meet the cultural and linguistic needs of specific geographical locations.",
        "Copywriting: They provide copywriting services to help businesses create compelling and persuasive copy for advertising, marketing, and sales materials.",
      ],
      content2:
        "IT Ghar Company's writing and translation services are aimed at helping businesses communicate effectively and reach their target audience in multiple languages. They use a professional and quality-oriented approach and the latest technologies to deliver accurate and effective writing and translation solutions.",
    },
    _id: 118,
    icon: "far fa-edit",
    banner: contentWrite,
  },
  {
    title: "UX Writing",
    slug: "ux-writing",
    type: "Writing & Translation",
    shortDescription:
      " Search engine optimization for online stores is known as eCommerce SEO",
    description: {
      content1:
        "IT Ghar Company provides comprehensive writing and translation services to businesses and organizations. Their services include:",
      items: [
        "Content Writing: They provide professional writing services to help businesses create high-quality and engaging content for websites, blogs, social media, email campaigns, and other marketing materials.",
        "Technical Writing: They specialize in creating clear and concise technical documentation for software, hardware, and other technical products.",
        "Translation: They offer translation services to help businesses communicate effectively with their target audience in multiple languages. Their translation services cover a wide range of industries, including technology, finance, healthcare, and more.",
        "Localization: They provide localization services to help businesses adapt their content, products, and services to meet the cultural and linguistic needs of specific geographical locations.",
        "Copywriting: They provide copywriting services to help businesses create compelling and persuasive copy for advertising, marketing, and sales materials.",
      ],
      content2:
        "IT Ghar Company's writing and translation services are aimed at helping businesses communicate effectively and reach their target audience in multiple languages. They use a professional and quality-oriented approach and the latest technologies to deliver accurate and effective writing and translation solutions.",
    },
    _id: 119,
    icon: "far fa-edit",
    banner: contentWrite,
  },
  {
    title: "Website Content",
    slug: "website-content",
    type: "Graphics & Design",
    shortDescription:
      " Search engine optimization for online stores is known as eCommerce SEO",
    description: {
      content1:
        "IT Ghar Company provides comprehensive writing and translation services to businesses and organizations. Their services include:",
      items: [
        "Content Writing: They provide professional writing services to help businesses create high-quality and engaging content for websites, blogs, social media, email campaigns, and other marketing materials.",
        "Technical Writing: They specialize in creating clear and concise technical documentation for software, hardware, and other technical products.",
        "Translation: They offer translation services to help businesses communicate effectively with their target audience in multiple languages. Their translation services cover a wide range of industries, including technology, finance, healthcare, and more.",
        "Localization: They provide localization services to help businesses adapt their content, products, and services to meet the cultural and linguistic needs of specific geographical locations.",
        "Copywriting: They provide copywriting services to help businesses create compelling and persuasive copy for advertising, marketing, and sales materials.",
      ],
      content2:
        "IT Ghar Company's writing and translation services are aimed at helping businesses communicate effectively and reach their target audience in multiple languages. They use a professional and quality-oriented approach and the latest technologies to deliver accurate and effective writing and translation solutions.",
    },
    _id: 120,
    icon: "far fa-edit",
    banner: contentWrite,
  },
];
